import type { MouseEvent } from 'react';
import { format } from 'date-fns';
import { fr } from 'date-fns/locale';
import type { InboxEmail } from '../../types/inbox.types';

export type EmailViewMode = 'html' | 'text';

type Props = {
  email: InboxEmail;
  onToggleViewMode: (mode: EmailViewMode) => void;
};

export function useEmailContentView(props: Props) {
  const sender = props.email.from_name || props.email.from_email;
  const receivedLabel = `Reçu le ${format(new Date(props.email.received_at), "EEEE d MMMM yyyy 'à' HH'h'mm", {
    locale: fr,
  })}`;

  function handleViewModeChange(_event: MouseEvent<HTMLElement>, mode: EmailViewMode | null) {
    if (mode) {
      props.onToggleViewMode(mode);
    }
  }

  return {
    sender,
    receivedLabel,
    hasAttachments: Boolean(props.email.attachments && props.email.attachments.length > 0),
    handleViewModeChange,
  };
}
